<template>
    <div class="bento-container">
        <!-- Page Header -->
        <div class="bento-header">
            <div class="header-content">
                <div class="header-icon">
                    <i class="el-icon-menu"></i>
                </div>
                <div class="header-text">
                    <h2>部门管理</h2>
                    <p>组织架构管理 · 层级关系维护</p>
                </div>
            </div>
            <div class="header-actions">
                <div class="header-search">
                    <div class="search-input-wrapper">
                        <i class="el-icon-search input-icon"></i>
                        <el-input v-model="formDatas.adName" placeholder="搜索部门名称" clearable size="medium"
                            class="ai-input" @keyup.enter.native="partserch"></el-input>
                    </div>
                </div>
                <el-button class="ai-btn" @click="partserch">
                    <i class="el-icon-search"></i>
                    搜索
                </el-button>
                <el-button class="ai-btn secondary" @click="resetSearch">
                    <i class="el-icon-refresh"></i>
                    重置
                </el-button>
                <el-button class="ai-btn secondary" @click="addForm">
                    <i class="el-icon-plus"></i>
                    新增部门
                </el-button>
            </div>
        </div>

        <!-- Bento Grid Layout -->
        <div class="bento-grid">
            <!-- Data Table Card - Full Width -->
            <div class="bento-card table-card full">
                <div class="card-header">
                    <span class="card-title">
                        <i class="el-icon-notebook-2"></i>
                        部门列表
                    </span>
                    <div class="card-actions">
                        <span class="ai-hint">
                            <i class="el-icon-info"></i>
                            支持树形结构展示
                        </span>
                    </div>
                </div>
                <div class="card-content">
                    <aj-table ref="ajTable" :data="tableData" :columns="tableColumns" :editable="tableEditable"
                        :use-internal-pagination="false" :currentPage.sync="formDatas.currentPage"
                        :pageSize.sync="formDatas.pageSize" :total="totalCount" row-id-key="adId" stripe
                        @page-change="handlePageChange" :is-tree-table="true" tree-children-key="children"
                        :default-expand-all="false" :expand-row-keys="expandRowKeys"
                        @cell-edit-confirm="handleTableEditConfirm" @operate-btn-click="handleOperateBtnClick"
                        @cell-edit-cancel="handleEditCancel" @selection-change="handleSelectionChange"
                        @row-click="handleRowClick">
                        <!-- 自定义树形展开图标列 -->
                        <template #tree-icon="{ row }">
                            <span class="tree-expand-icon"
                                :class="{ 'is-leaf': !row.children || row.children.length === 0 }">
                                <i v-if="row.children && row.children.length > 0"
                                    :class="expandRowKeys.includes(row.adId) ? 'el-icon-arrow-down' : 'el-icon-arrow-right'">
                                </i>
                                <i v-else class="el-icon-document"></i>
                            </span>
                        </template>
                    </aj-table>
                </div>
            </div>
        </div>

        <!-- Dialogs -->
        <aj-form-add ref="add_form" :formConfig="formConfig" :formData="form" :dialogVisible="addDialogVisible"
            dialogTitle="新增部门" dialogWidth="600px" formSize="small" cancelText="关闭" confirmText="提交新增"
            @confirm="handleAddConfirm" @update:dialogVisible="val => addDialogVisible = val">
        </aj-form-add>
        <aj-form-edit ref="edit_form" :formConfig="formConfig" :formData="form" :dialogVisible="editDialogVisible"
            @update:dialogVisible="val => editDialogVisible = val" dialogTitle="编辑部门" labelWidth="100px"
            @confirm="handleEditConfirm">
        </aj-form-edit>
    </div>
</template>

<script>
import qs from 'qs';
import axios from 'axios';
import config from '../../api/env.js';
import { getDepartmentList, addDepartment, updateDepartment, deleteDepartment } from "../../api/api";
export default {
    name: "",
    components: {},
    data() {
        return {
            addDialogVisible: false,
            editDialogVisible: false,
            form: {},
            formConfig: [],
            totalCount: 0,
            tableData: [],
            expandRowKeys: [],
            tableColumns: [
                { type: 'index', label: '序号', width: 80, align: 'center', },
                { label: '', prop: 'treeIcon', width: 50, align: 'center', slot: 'tree-icon' },
                { label: '部门名称', prop: 'adName', align: 'center', editable: true },
                { label: '排序', prop: 'adOrder', width: 150, },
                {
                    type: 'operation',
                    label: '操作',
                    prop: 'operation',
                    width: 250,
                    buttons: [
                        { key: 'edit', text: '编辑', icon: 'el-icon-edit' },
                        { key: 'delete', text: '删除', icon: 'el-icon-delete', disabled: (row) => row.adId === 1, }
                    ]
                }
            ],
            tableEditable: false,

            formDatas: {
                adName: '',
                currentPage: 1,
                pageSize: 20,
            },
        };
    },
    activated() {
        this.watchFlag = true;
        this.$nextTick(() => {
            this.windheight = this.$store.state.windheight;
            this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        });
    },
    watch: {
        "$store.state.windheight"(val) {
            this.$nextTick(() => {
                if (this.watchFlag) {
                    this.tableHight = val - 200 - val * 0.04;
                }
            });
        },
    },
    deactivated() {
        this.watchFlag = false;
    },
    created() {
        this.windheight = this.$store.state.windheight
        this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        this.partserch()
    },
    mounted() {
    },
    methods: {
        // 编辑提交
        async handleEditConfirm({ data }) {
            console.log('编辑提交：', data);
            try {
                await this.$confirmDialog({
                    content: '确认编辑该部门吗？',
                    type: 'success'
                })
                // 确定逻辑
                const newData = JSON.parse(JSON.stringify(data));
                updateDepartment(newData).then(res => {
                    if (res.status === 200) {
                        this.$message.success('编辑成功');
                        this.$refs.edit_form.cancelDiaLog();
                        this.partserch();
                    } else {
                        this.$message.error('编辑失败');
                    }
                })
            } catch {
                // 取消逻辑
                this.$message.error('取消');
            }
        },
        // 编辑取消
        handleEditCancel({ type }) {
            console.log('编辑取消：', type);
        },
        // 表单项变更监听
        handleItemChange({ prop, value, type }) {
            console.log(`【${type}】${prop} 变更为：`, value);
        },
        // 新增提交
        async handleAddConfirm({ data }) {
            console.log('新增提交：', data);
            try {
                await this.$confirmDialog({
                    content: '确认新增该部门吗？',
                    type: 'success'
                })
                // 确定逻辑
                const newData = JSON.parse(JSON.stringify(data));
                addDepartment(newData).then(res => {
                    if (res.status === 200) {
                        this.$message.success('新增成功');
                        this.$refs.add_form.cancelDiaLog();
                        this.partserch();
                    } else {
                        this.$message.error('新增失败');
                    }
                })
            } catch {
                // 取消逻辑
                this.$message.error('取消');
            }
        },
        // 新增取消
        handleAddCancel({ type }) {
            console.log('新增取消：', type);
            // 可执行取消后的逻辑，如重置数据、提示等
        },
        addForm() {
            this.addDialogVisible = true;
        },
        async getFormInit() {
            this.formConfig = [
                [{
                    type: 'select', label: '上级部门', prop: 'adParentId', placeholder: '请选择部门', span: 24, required: false, options: [...this.tableData], optionLabelKey: 'adName',
                    optionValueKey: 'adId',
                },],
                [{ type: 'input', label: '部门名称', prop: 'adName', placeholder: '请输入部门', span: 24, required: true, },],
                [{ type: 'input', label: '排序', prop: 'adOrder', placeholder: '请输入排序', span: 24, required: false },],
            ];
            console.log(this.formConfig, this.tableData);

            this.form = {
                adParentId: '',
                adName: '',
                adOrder: '',
            };
        },
        // 分页切换回调
        handlePageChange({ currentPage, pageSize }) {
            console.log('分页切换：', `第${currentPage}页，每页${pageSize}条`);
            // 外部分页时：调用接口获取对应页数据
            // this.fetchTableData(currentPage, pageSize);
        },
        // 编辑确认回调
        handleTableEditConfirm({ row, prop, value }) {
            this.$message.success(`编辑成功：行${row}的${prop}列修改为${value}`);
            console.log(this.$refs.ajTable);
            this.$refs.ajTable.clearEditingState();
            console.log('编辑确认：', row, prop, value);
        },
        // 操作按钮点击回调（默认按钮）
        handleOperateBtnClick({ btn, row }) {
            switch (btn.key) {
                case 'edit':
                    this.handleEdit(row);
                    break;
                case 'delete':
                    this.handleDelete(row);
                    break;
            }
        },
        // 行点击展开/折叠
        handleRowClick({ row }) {
            // 先判断 row 是否存在
            if (!row) return;
            // 再判断是否有 children
            if (!row.children || row.children.length === 0) return;
            const index = this.expandRowKeys.indexOf(row.adId);
            if (index > -1) {
                this.expandRowKeys.splice(index, 1);
            } else {
                this.expandRowKeys.push(row.adId);
            }
        },
        // 选中状态变化回调
        handleSelectionChange(selRows) {
            console.log('当前页选中行：', selRows.map(row => row.id));
        },
        // 查看操作
        handleView(row) {
            this.$message.info(`查看用户：${row.name}，手机号：${row.phone}`);
        },
        // 编辑操作
        handleEdit(row) {
            this.form = JSON.parse(JSON.stringify(row));
            this.editDialogVisible = true;
        },
        // 删除操作
        async handleDelete(row) {
            try {
                await this.$confirmDialog({
                    content: '确认删除该部门吗？',
                    type: 'danger'
                })
                // 确定逻辑
                deleteDepartment({ adId: row.adId }).then(res => {
                    if (res.status === 200) {
                        this.$message.success('删除成功');
                        this.partserch();
                    } else {
                        this.$message.error('删除失败');
                    }
                })
            } catch {
                // 取消逻辑
                this.$message.error('取消');
            }
        },
        async partserch() {
            this.formDatas.currentPage = 1;
            getDepartmentList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.getFormInit()
            });
        },
        resetSearch() {
            this.formDatas.adName = '';
            this.partserch();
        },

    },
};
</script>

<style scoped>
/* Bento Grid Layout */
.bento-container {
   padding: 15px 20px;
    min-height: 100%;
    background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
}

/* Page Header */
.bento-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;
    padding: 20px 24px;
    background: white;
    border-radius: 16px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05), 0 1px 2px rgba(0, 0, 0, 0.1);
}

.header-content {
    display: flex;
    align-items: center;
    gap: 16px;
}

.header-icon {
    width: 48px;
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border-radius: 12px;
    color: white;
    font-size: 24px;
}

.header-text h2 {
    margin: 0;
    font-size: 20px;
    font-weight: 600;
    color: #1e293b;
}

.header-text p {
    margin: 4px 0 0;
    font-size: 13px;
    color: #64748b;
}

.header-actions {
    display: flex;
    align-items: center;
    gap: 16px;
}

.header-search {
    flex: 1;
    max-width: 280px;
}

/* AI Button Styles */
.ai-btn {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 10px 20px;
    border: none;
    border-radius: 10px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
    box-shadow: 0 4px 14px rgba(102, 126, 234, 0.4);
}

.ai-btn:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(102, 126, 234, 0.5);
}

.ai-btn.secondary {
    background: white;
    color: #64748b;
    border: 1px solid #e2e8f0;
    box-shadow: none;
}

.ai-btn.secondary:hover {
    background: #f8fafc;
    border-color: #cbd5e1;
}

/* Bento Grid */
.bento-grid {
    /* display: grid; */
    grid-template-columns: 1fr;
    gap: 20px;
}

/* Bento Card */
.bento-card {
    background: white;
    border-radius: 16px;
    padding: 20px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05), 0 1px 2px rgba(0, 0, 0, 0.1);
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.bento-card:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.bento-card.full {
    width: 100%;
}

.card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
    padding-bottom: 12px;
    border-bottom: 1px solid #f1f5f9;
}

.card-title {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 15px;
    font-weight: 600;
    color: #1e293b;
}

.card-title i {
    color: #667eea;
}

.ai-hint {
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 12px;
    color: #94a3b8;
    padding: 4px 10px;
    background: #f8fafc;
    border-radius: 20px;
}

/* Search Card */
.search-input-wrapper {
    position: relative;
}

.input-icon {
    position: absolute;
    left: 12px;
    top: 50%;
    transform: translateY(-50%);
    color: #94a3b8;
    z-index: 1;
}

.ai-input ::v-deep .el-input__inner {
    padding-left: 36px;
    border-radius: 10px;
    border: 1px solid #e2e8f0;
    background: #f8fafc;
    transition: all 0.3s;
}

.ai-input ::v-deep .el-input__inner:focus {
    border-color: #667eea;
    background: white;
    box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

/* Table Card */
.table-card {
    width: 100%;
}

.card-content {
    padding: 4px 0;
}

/* Tree Table Styles */
.tree-expand-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    cursor: pointer;
    border-radius: 4px;
    transition: all 0.2s;
}

.tree-expand-icon:hover {
    background: #f1f5f9;
}

.tree-expand-icon i {
    font-size: 14px;
    color: #667eea;
    transition: transform 0.2s;
}

.tree-expand-icon.is-leaf i {
    color: #cbd5e1;
}

/* Make rows clickable for tree expansion */
.card-content ::v-deep .ve-table tbody tr {
    cursor: pointer;
}

.card-content ::v-deep .ve-table tbody tr:hover {
    background: #f8fafc !important;
}

/* Scrollbar */
.easetable::-webkit-scrollbar {
    display: none;
}

.ve-table-container {
    height: auto !important;
}

/* Responsive */
@media (max-width: 768px) {
    .bento-header {
        flex-direction: column;
        gap: 16px;
        align-items: flex-start;
    }

    .header-actions {
        width: 100%;
        flex-wrap: wrap;
    }

    .header-search {
        max-width: 100%;
        flex: 1;
    }
}
</style>